import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { twilioCountryCodes } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchCountry(): Promise<apiResult> {
  const response = await fetch(twilioCountryCodes, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type apiResult = {
  Data: Array<{
    Abbreviation: string;
    ISDCode: null;
    Id: number;
    Name: string;
    SortOrder: number | null;
  }>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TResult = any;

function useGetTwilioCountryCodes(): UseQueryResult<TResult | TError> {
  return useQuery(
    ['get_country'],
    async () => {
      const result = await fetchCountry();
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTwilioCountryCodes };
